module.exports = __webpack_public_path__ + "static/media/image_2_1.e80c7b94.png";